import React, { Fragment, useState } from 'react';
import { createUseStyles } from 'src/theming';
import Card from 'src/components/Card';
import MigrateCustomerDialog from './components/MigrateCustomerDialog';
import { IoMdCheckmarkCircleOutline as SuccessIcon } from '@react-icons/all-files/io/IoMdCheckmarkCircleOutline';
import { Button } from '@material-ui/core';
import useSite from '../../hooks/useSite';

const useStyles = createUseStyles({
  root: {
    marginBottom: 25,
    display: 'flex',
    flexDirection: 'column',
    padding: 22,
  },
  success: {
    marginBottom: 25,
    color: '#4caf50',
    backgroundColor: '#10e31029',
    display: 'flex',
    alignItems: 'center',
    padding: '6px 16px',
    fontSize: '0.875rem',
    fontWeight: 400,
    borderRadius: 4,
    '& $message': {
      padding: '8px 0 5px 0',
    },
    '& svg': {
      opacity: 0.9,
      marginRight: 12,
      '& path': {
        color: '#4caf50',
      },
    },
  },
  bottomContainer: {
    display: 'flex',
  },
  message: {},
  information: {
    fontSize: 14,
    color: '#98a6ad',
    marginBottom: '.5rem',
  },
  title: {
    fontWeight: 700,
    color: '#6c757d',
    fontSize: '.9rem',
    letterSpacing: '.02em',
    marginBottom: '.5rem',
    marginTop: 0,
    textTransform: 'uppercase',
  },
});

interface Props {
  customerId: number;
  customerName: string;
  address: string;
  city: string;
  siret: string;
  phoneNumber: string;
  fax: string;
}

const CustomerMigrationView: React.FC<Props> = ({
  customerId,
  customerName,
  address,
  city,
  siret,
  phoneNumber,
  fax,
}) => {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const { site } = useSite();

  const handleSiteMigrated = () => {
    setOpenDialog(false);
    location.reload();
  };

  const handleClickMigrate = () => {
    setOpenDialog(true);
  };

  const legacyCustomer = {
    id: customerId,
    name: customerName,
    address,
    city,
    siret,
    phoneNumber,
    fax,
  };

  if (site.status === 'fetching') {
    return <div>Chargement ...</div>;
  }

  return (
    <Fragment>
      {site.status === 'fetched' && site.data?.id ? (
        <div className={classes.success}>
          <SuccessIcon size={22} />
          <div className={classes.message}>Ce client a bien été migré</div>
        </div>
      ) : (
        <Card className={classes.root}>
          <div className={classes.title}>Information</div>

          <div className={classes.information}>
            {site.status === 'error' && (
              <>
                {site.error.message} <br />
              </>
            )}
            Afin de permettre l'ouverture d'un espace client pour ce client, une intervention manuelle de migration est
            requise.
          </div>

          <div className={classes.bottomContainer}>
            <Button variant='contained' color='primary' size='small' onClick={handleClickMigrate}>
              Migrer
            </Button>
          </div>
        </Card>
      )}

      <MigrateCustomerDialog
        legacyCustomer={legacyCustomer}
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onMigrateSiteDone={handleSiteMigrated}
      />
    </Fragment>
  );
};

export default CustomerMigrationView;
